export const OPEN_LOGIN = 'home/OPEN_LOGIN';
export const OPEN_SIGNUP = 'home/OPEN_SIGNUP';
export const CLOSE_LOGIN = 'home/CLOSE_LOGIN';
export const CLOSE_SIGNUP = 'home/CLOSE_SIGNUP';
